import React, { Component } from 'react';

const QuestionPrice = ({active_price, changeActivePrice, formatters}) => {

  const price_range = {
    max: 8000000,
    min: 0,
    step_thresh: 2000000,
    steps: [100000, 1000000]
  }

  let price_counter = price_range.min;
  const price_range_array = [];
  while (price_counter <= price_range.max) {
    price_range_array.push(price_counter);
    if (price_counter < price_range.step_thresh) {
      price_counter += price_range.steps[0];
    } else {
      price_counter += price_range.steps[1];
    }
  }

  const handleChange = (e) => {
    changeActivePrice(e.target.value);
  }

  const handleCrement = (type) => {
    const current_index = price_range_array.indexOf(active_price);
    let next_price;
    if (type === 'increment') {
      next_price = price_range_array[current_index + 1];
      if (!next_price) next_price = price_range.max;
    } else {
      next_price = price_range_array[current_index - 1];
      if (!next_price) next_price = price_range.min;
    }
    changeActivePrice(next_price);
  }

  const handlePriceContainerClick = (e) => {
    // TDOD hard coding with here is probably a bad idea
    let x = e.clientX;
    let width = 326;
    let x_ratio = x/width;
    let sim_price = Math.round(x_ratio * price_range.max);
    let first_above_i;
    for (let [i, price] of price_range_array.entries()) {
      if (price > sim_price) {
        first_above_i = i;
        break;
      }
    }
    let above = price_range_array[first_above_i];
    let below = price_range_array[first_above_i - 1];
    let above_diff = above - sim_price;
    let below_diff = sim_price - below;
    let new_i;
    if (below_diff < above_diff) {
      new_i = first_above_i - 1;
    } else {
      new_i = first_above_i;
    }
    let new_price = price_range_array[new_i];
    changeActivePrice(new_price);
  }

  return (
    <div>
      <div className="py1 px2">
        Where can I buy a property for
      </div>
      <div
        className="PriceNumberContainer relative"
      >
        <div className="PriceContainer no-select border relative tnum py1"
          onClick={handlePriceContainerClick.bind(this)}
          style={{
            cursor: 'ew-resize',
            paddingTop: '0.5rem',
            paddingBottom: '0.5rem'
          }}
        >
          <div className="PriceBar absolute left-0 top-0 height-100"
            style={{background: '#fafafa', width: Math.round(active_price/price_range.max * 100) + '%'}}
          ></div>
          <div className="PriceDisplayer relative center px2 h1">
            {formatters.dollarFormat(active_price)}
          </div>
        </div>
        <div className="PriceControls absolute right-0 h6 top-0 border-top border-bottom height-100"
        >
          <div
            onClick={handleCrement.bind(this, 'increment')}
            className="PriceControl no-select absolute right-0 height-50 top-0 flex flex-align-center justify-center pointer col-12 border-bottom">▲</div>
          <div
            onClick={handleCrement.bind(this, 'decrement')}
            className="PriceControl no-select absolute right-0 height-50 bottom-0 flex flex-align-center justify-center pointer col-12">▼</div>
        </div>
      </div>
    </div>
  )
}

export default QuestionPrice;


/** WEBPACK FOOTER **
 ** ./src/components/QuestionPrice.js
 **/